import React, { useMemo, useState } from 'react'
import { ScrollView, Text, View } from 'react-native'
import { useCssStyle } from '../../customHook/getCssStyle';
import { useTranslation } from 'react-i18next';
import { ImageComp } from '../../components/Image/Image';
import HeaderWithBack from '../../components/Header/headerWithBack';
import { EDIT } from '../../assets';
import CustomPressable from '../../components/customPressable/customPressable';
import { useDispatch, useSelector } from 'react-redux';
import moment from 'moment';
import { getCleanUrl, toBool } from '../../utils/Helper';
import { formatTime } from '../../js/formatTime';

const ActivitiesBookings = (props) => {
    const { bookingOverviewDetails, setBookingOverviewDetails, myBookings, handleNext, handleGoBack, updateLoaderState, handleRetryFetchBookings, updateFetchApiError } = props;

    const getStyles = useCssStyle();
    const { t } = useTranslation();
    const dispatch = useDispatch();

    const imageUrl = useMemo(()=> t('way_activity.booking_page_hero_img_url'), [t])
    const { extraConfigParam } = useSelector(state => state.deviceConfigSlice)

    const dateFormat = extraConfigParam?.DATE_FORMAT;
    const TIME_FORMAT = extraConfigParam?.TIME_FORMAT_MERIDIEM || false;


    const formatDate = (dateString) => {
        return `${moment(dateString).format(dateFormat.toUpperCase())}`
    };


    const groupingByDate = (data) => {
        const groupedAccToDay = new Map();

        data.sort((a, b) => {
            return (
                new Date(a.event.startDateTime.split("T")[0]).getTime() -
                new Date(b.event.startDateTime.split("T")[0]).getTime()
            );
        });
        

        data.forEach((d) => {
            const groupingKey = formatDate(d.event.startDateTime.split("T")[0]);
            if (groupedAccToDay.has(groupingKey)) {
                const keyData = groupedAccToDay.get(groupingKey);
                keyData.push(d);
            } else {
                groupedAccToDay.set(groupingKey, [d]);
            }
        });

        return groupedAccToDay;
    };



    const renderHeader = () => {
        return (
            <View style={getStyles(['widgetmainContainerHeaderContainer', 'activitiesBookingHeaderContainer'])} id='activitiesBookingHeaderContainer'>
                {
                    imageUrl && <ImageComp source={getCleanUrl(imageUrl)} style={getStyles(['widgetmainContainerHeaderImg', 'activitiesBookingHeaderImg'])} id={"activitiesBookingHeaderImg"}/>
                }
                <View style={getStyles(['widgetmainContainerHeaderTitleContainer', 'activitiesBookingMainPageHeaderTitleContainer'])} id='activitiesBookingMainPageHeaderTitleContainer'>
                    <Text style={getStyles(['widgetmainContainerHeaderTitle', 'activitiesBookingHeaderTitle'])} id='activitiesBookingHeaderTitle'>{t('way_activity.mybooking.heading')}</Text>
                    <Text style={getStyles(['widgetmainContainerHeaderSubTitle', 'activitiesBookingHeaderSubTitle'])} id='activitiesBookingHeaderSubTitle'>{t('way_activity.mybooking.sub_heading')}</Text>
                    <Text style={getStyles(['widgetmainContainerHeaderSubTitle2', 'activitiesBookingHeaderSubTitle2'])} id='activitiesBookingHeaderSubTitle2'>{t('way_activity.mybooking.sub_heading2')}</Text>
                </View>
            </View>
        )
    }


    return (
        <View style={getStyles(['widgetRootContainer', 'activitiesBookingRootContainer'])} id='activitiesBookingRootContainer'>
            <HeaderWithBack handleCustomBackPress={handleGoBack} />
            <ScrollView
                automaticallyAdjustKeyboardInsets={true} 
                contentContainerStyle={getStyles(['widgetmainContainer', 'activitiesBookingMainContainer'])} 
                showsVerticalScrollIndicator={false}
                id='activitiesBookingMainContainer'
            >
                {renderHeader()}

                <View style={getStyles(['widgetmainContainerChildContainer', 'activitiesBookingMainContainerChildContainer'])} id='activitiesBookingMainContainerChildContainer'>
                    <Text style={getStyles(["activitiesBookingMainContainerHeader"])} id='activitiesBookingMainContainerHeader'>{t("way_activity.my_bookings")}</Text>
                    {myBookings?.length ? Array.from(groupingByDate(myBookings)?.entries())
                        .map(([day, dataOnThatDay]) => {
                            return (
                                <View style={getStyles(['activitiesBookingItemContainer'])} id='activitiesBookingItemContainer'>
                                    <Text style={getStyles(['activitiesBookingItemDay'])} id='activitiesBookingItemDay'>{day}</Text>
                                    
                                    {dataOnThatDay.map((booking, index) => {
                                        return (
                                        <>
                                            <View key={index} style={getStyles(["list_itemContainer", 'activitiesBookingSubItemContainer'])} id='activitiesBookingSubItemContainer'>
                                                {/* {booking.imageUrl && <ImageComp style={getStyles([''])} source={booking.imageUrl} />} */}
                                                <View style={getStyles(["activitiesBookingCheckedBox"])} id='activitiesBookingCheckedBox'></View>

                                                <View style={getStyles(['activitiesBookingDateContainer'])} id='activitiesBookingDateContainer'>
                                                    <Text style={getStyles(['activitiesBookingBookingExperienceText'])} id='activitiesBookingBookingExperienceText'>
                                                        {booking.experience.title}
                                                    </Text>

                                                    <Text style={getStyles(['activitiesBookingBookingExperienceDate'])} id='activitiesBookingBookingExperienceDate'>
                                                        {booking.event.startDateTime?.split("T")[1] && formatTime(booking.event.startDateTime.split("T")[1], toBool(TIME_FORMAT))}
                                                    </Text>
                                                </View>

                                                <CustomPressable style={getStyles(['activitiesBookingEditButtonContainer'])} id='activitiesBookingEditButtonContainer' onPress={()=> setBookingOverviewDetails(booking)} disabled={booking.status === "cancelled"}>
                                                    {booking.status === "confirmed" ? (
                                                        <ImageComp 
                                                            style={getStyles(['activitiesBookingEditButton'])}
                                                            id={"activitiesBookingEditButton"}
                                                            source={EDIT}
                                                        />
                                                    ) : null}

                                                    {booking.status === "cancelled"  && 
                                                        <Text style={getStyles([ { color: "red" }, 'activitiesBookingCancelledButton'])} id='activitiesBookingCancelledButton'>
                                                            {t("way_activity.mybooking.cancelled")}
                                                        </Text>}
                                                </CustomPressable>
                                            </View>
                                        </>)
                                        })
                                    }
                                </View>
                            )})
                    :   <View style={getStyles(['activitiesBookingNoReservationFoundContainer'])} id='activitiesBookingNoReservationFoundContainer' >
                            <Text style={getStyles(['activitiesBookingNoReservationTxt'])} id='activitiesBookingNoReservationTxt'>
                                {t("way_activity.mybooking.no_reservation")}
                            </Text>
                            <CustomPressable style={getStyles(['spaBookingRetryButtonContainer'])} id="spaBookingRetryButtonContainer" onPress={() => handleRetryFetchBookings()}>
                                <Text style={getStyles(["activitiesBookingNoReservationRetry"])} id='activitiesBookingNoReservationRetry'>{t('way_activity.retry')}</Text>
                            </CustomPressable>
                        </View>
                        }
                </View>
            </ScrollView>

            <View id='activitiesBookingNextButtonContainer' style={getStyles(['activitiesBookingNextButtonContainer'])}>
                <CustomPressable style={getStyles(['primaryBtn'])} id="primaryBtn" onPress={handleNext}>
                    <Text style={getStyles(['primaryBtnTxt'])} id='primaryBtnTxt'>
                        {t('way_activity.mybooking.view_all')}
                    </Text>
                </CustomPressable>
            </View>
        </View>
    )
}

export default ActivitiesBookings
